module.exports = __webpack_public_path__ + "img/you.e5b171f4.png";